import { Skeleton } from 'antd'
import React from 'react'

const ANTDSkeleton = ({ ...props }) => {
  return <Skeleton {...props} />
}

export default ANTDSkeleton
